export default "__VITE_ASSET__h9D4e01Q__"